/* ══════════════════════════════════════════════════════
   GADGEX — Shared page effects
   Particles · Reveal on scroll · Counters
══════════════════════════════════════════════════════ */

// ── PARTICLES (mini hero) ──
(function() {
  const canvas = document.querySelector('.page-hero-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
  resize();
  window.addEventListener('resize', resize, { passive: true });

  const COUNT = 50;
  const pts = Array.from({ length: COUNT }, () => ({
    x: Math.random(),
    y: Math.random(),
    r: Math.random() * 1.4 + 0.3,
    sx: (Math.random() - 0.5) * 0.0003,
    sy: -(Math.random() * 0.0003 + 0.0001),
    o: Math.random() * 0.55 + 0.15,
    c: Math.random() > 0.5 ? '0,212,255' : '123,47,255'
  }));

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const w = canvas.width, h = canvas.height;
    pts.forEach(p => {
      ctx.beginPath();
      ctx.arc(p.x * w, p.y * h, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${p.c},${p.o})`;
      ctx.fill();
      p.x += p.sx; p.y += p.sy; p.o -= 0.0012;
      if (p.y < -0.02 || p.o <= 0) {
        p.x = Math.random(); p.y = 1.02;
        p.o = Math.random() * 0.55 + 0.15;
        p.r = Math.random() * 1.4 + 0.3;
      }
    });
    requestAnimationFrame(draw);
  }
  draw();
})();

// ── NAV scroll state (for pages with sticky nav) ──
(function() {
  const nav = document.querySelector('nav.top');
  if (!nav) return;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── REVEAL ON SCROLL with stagger ──
(function() {
  const revealEls = document.querySelectorAll('.rv, .rvL, .rvR, .rvS');
  if (!revealEls.length) return;
  const staggerParents = '.prod-grid, .cat-grid, .test-grid, .cinfo, .stats, .icon-grid, .socials, ' +
                         '.cart-list, .sug-grid, .related-grid, .thumbs, .contact-cards, .faq-list, ' +
                         '.subject-chips, .express, .review-list';
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const parent = el.closest(staggerParents);
      const delay = parent ? Array.from(parent.children).indexOf(el) * 85 : 0;
      setTimeout(() => el.classList.add('on'), delay);
      io.unobserve(el);
    });
  }, { threshold: 0.12 });
  revealEls.forEach(el => io.observe(el));
})();

// ── COUNTERS ──
(function() {
  const counters = document.querySelectorAll('.n[data-target]');
  if (!counters.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = +el.dataset.target;
      const suffix = el.dataset.suffix || '+';
      const dur = 1800;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        const val = Math.floor(eased * target);
        el.textContent = (val >= 1000 ? val.toLocaleString() : val) + suffix;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(el => io.observe(el));
})();
